angular.module 'zc.master.zcliteInvoices'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master.zcliteInvoices',
    url: '/zclite_invoices'
    views:
      'content@':
        templateUrl: '/templates/master.zclite_invoices/list.html'
        controller: 'MasterZcliteInvoicesListCtrl'
        resolve:
          projects: (MasterProject) ->
            MasterProject.all()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_invoices/routes.coffee